module.exports = __webpack_public_path__ + "static/img/Push pull 3.0m tampak samping.c39bcf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Push pull 3.0m tampak samping.jpg
// module id = 97
// module chunks = 1